module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/play-970238ab9f8a5cd718054c8bc35f2c90.svg";